import React, { createRef, useEffect, useRef, useState } from "react";
import { styled } from "@mui/material/styles";
import Globe from "react-globe.gl";
import { useTranslation } from "react-i18next";
import { useSnackbar } from "notistack";
import { authHeader, guidGenerator, useViewport } from "../../helpers";
// import { fetchEventSource } from "@microsoft/fetch-event-source";
import {
  Button,
  CircularProgress,
  Container,
  Paper,
  Slide,
} from "@mui/material";
import { Fade, Typography } from "@mui/material";
import { ToggleButton, ToggleButtonGroup } from "@mui/material";
import { CSSTransition, TransitionGroup } from "react-transition-group";
import CloseIcon from "@mui/icons-material/Close";
import BackdropCardInfo from "./BackdropCardInfo";
// import { myExpariencesService } from '../../services';
import LogoByAds from "../../assets/faz.png";
import Lottie from "lottie-react";
import RocketLaunch from "../../assets/rocketLaunchLottie.json";
import ViewLottie from "../../assets/viewLottie.json";
import LikeLottie from "../../assets/likeLottie.json";
import ShareLottie from "../../assets/shareLottie.json";
import ScanLottie from "../../assets/scanLottie.json";
import LinkLottie from "../../assets/linkLottie.json";
import WebviewLottie from "../../assets/webviewLottie.json";
import PaymentLottie from "../../assets/paymentLottie.json";
import UniqueLottie from "../../assets/unique.json";

import "./transitions-style.css";
import MyMapContainer from "../geoloc/MyMapContainer";
import { getUserToken, statsSocket } from "../../socket";

const PREFIX = "GlobeGl";

const classes = {
  loadingContainer: `${PREFIX}-loadingContainer`,
  globeNotif: `${PREFIX}-globeNotif`,
  notifContainer: `${PREFIX}-notifContainer`,
  exparienceImage: `${PREFIX}-exparienceImage`,
  textContainer: `${PREFIX}-textContainer`,
  zoneBottomMenu: `${PREFIX}-zoneBottomMenu`,
  closeIconBackdrop: `${PREFIX}-closeIconBackdrop`,
  fifoContainer: `${PREFIX}-fifoContainer`,
  fifoExparienceContainer: `${PREFIX}-fifoExparienceContainer`,
  fifoList: `${PREFIX}-fifoList`,
  noItemsContainer: `${PREFIX}-noItemsContainer`,
  fifoItem: `${PREFIX}-fifoItem`,
  fifoImage: `${PREFIX}-fifoImage`,
  exparienceNameContainer: `${PREFIX}-exparienceNameContainer`,
  fifoExparienceName: `${PREFIX}-fifoExparienceName`,
  fifoTitleRow: `${PREFIX}-fifoTitleRow`,
  toggleFilters: `${PREFIX}-toggleFilters`,
  filterButtonMargin: `${PREFIX}-filterButtonMargin`,
  noItemsTitle: `${PREFIX}-noItemsTitle`,
  customIcon: `${PREFIX}-customIcon`,
  customIconInItem: `${PREFIX}-customIconInItem`,
  toggleMapButton: `${PREFIX}-toggleMapButton`,
};

const Root = styled("div")(({ theme }) => ({
  [`& .${classes.loadingContainer}`]: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    margin: "2rem 0",
  },

  [`& .${classes.globeNotif}`]: {
    marginTop: "3rem",
    backgroundColor: "#484848 !important",
    color: "#a5893e !important",
  },

  [`& .${classes.notifContainer}`]: {
    display: "flex",
    alignItems: "center",
    width: "100%",
  },

  [`& .${classes.exparienceImage}`]: {
    width: "45px",
    height: "45px",
    marginRight: "0.5rem",
  },

  [`& .${classes.textContainer}`]: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
  },

  [`& .${classes.zoneBottomMenu}`]: {
    zIndex: 9999,
    width: "100%",
    minHeight: "270px",
    position: "fixed",
    left: 0,
    bottom: "0",
    borderTopLeftRadius: "10px",
    borderTopRightRadius: "10px",
    display: "flex",
    flexDirection: "row",
    justifyContent: "center",
    backgroundColor: "#000000a6",
  },

  [`& .${classes.closeIconBackdrop}`]: {
    position: "absolute",
    right: "10px",
    top: "10px",
    cursor: "pointer",
    color: "white",
  },

  [`& .${classes.fifoContainer}`]: {
    padding: "0.5rem 0.5rem, 0.5rem 0",
    position: "fixed",
    bottom: 0,
    left: 0,
    width: "100%",
    borderTop: "1px solid #343430",
    backgroundColor: "#343434",
  },

  // [`& .${classes.fifoExparienceContainer}`]: {
  //   [theme.breakpoints.up("md")]: {
  //     position: "fixed",
  //     bottom: 0,
  //     left: 0,
  //   },
  //   marginTop: "4rem",
  //   position: "relative",
  //   width: "100%",
  //   borderTop: "1px solid #343430",
  //   backgroundColor: "#343434",
  // },

  [`& .${classes.fifoList}`]: {
    minHeight: "174px",
    backgroundColor: "#424242",
    overflowX: "auto",
    width: "100%",
    display: "flex",
    padding: "0.75rem",
    paddingRight: "5rem",
    "&::-webkit-scrollbar": {
      width: "5px",
      height: "5px",
    },
    "&::-webkit-scrollbar-thumb": {
      backgroundColor: theme.palette.primary.main,
      borderRadius: "3px",
    },
    "&::-webkit-scrollbar-track": {
      backgroundColor: "rgb(181 154 79 / 58%)",
      borderRadius: "10px",
    },
  },

  [`& .${classes.noItemsContainer}`]: {
    // height: '150px',
    background: "#424242",
  },

  [`& .${classes.fifoItem}`]: {
    padding: "0.5rem",
    height: "150px",
    minWidth: "150px",
    border: "1px solid #343430",
    borderRadius: "12px",
    marginRight: "1rem",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    boxShadow:
      "0px 2px 4px -1px rgb(0 0 0 / 20%), 0px 4px 5px 0px rgb(0 0 0 / 14%), 0px 1px 10px 0px rgb(0 0 0 / 12%)",
    // justifyContent: 'space-between',
    position: "relative",
  },

  [`& .${classes.fifoImage}`]: {
    width: "100px",
    height: "80px",
    objectFit: "contain",
  },

  [`& .${classes.exparienceNameContainer}`]: {
    height: "100%",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },

  [`& .${classes.fifoExparienceName}`]: {
    marginTop: "0.25rem",
    maxWidth: "140px",
    textAlign: "center",
    fontSize: "12px",
  },

  [`& .${classes.fifoTitleRow}`]: {
    display: "flex",
    justifyContent: "space-between",
    marginLeft: "0.5rem",
  },

  [`& .${classes.toggleFilters}`]: {
    display: "flex",
    overflowX: "auto",
    overflowY: "hidden",
    margin: "0.5rem 0",
    [theme.breakpoints.up("sm")]: {
      margin: "0.5rem 1rem",
    },
    height: "40px",
    "&::-webkit-scrollbar": {
      width: "0px",
      height: "0px",
    },
  },

  [`& .${classes.filterButtonMargin}`]: {
    paddingLeft: 0,
    marginRight: "0.5rem",
    border: "1px solid #ffffff21 !important",
    borderRadius: "4px !important",
    lineHeight: "1.2",
  },

  [`& .${classes.noItemsTitle}`]: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    width: "100%",
    position: "absolute",
    top: "50%",
    transform: "translateY(-50%)",
  },

  [`& .${classes.customIcon}`]: {
    width: "40px",
    height: "40px",
  },

  [`& .${classes.customIconInItem}`]: {
    width: "40px",
    height: "40px",
    position: "absolute",
    top: 0,
    right: "-7px",
  },

  [`& .${classes.toggleMapButton}`]: {
    position: "absolute",
    left: "1.5rem",
    top: "-2.5rem",
  },
}));

const MAX_POINTS = 600;

const GlobeGl = (props) => {
  const { height, width } = useViewport();

  const { t } = useTranslation();
  const { enqueueSnackbar } = useSnackbar();
  const globeEl = useRef();
  const [expariences, setExpariences] = useState([]);
  const [savedData, setSavedData] = useState([]);
  const [status, setStatus] = useState(null);
  const [globeWidth, setGlobeWidth] = useState(-1);
  const [newElement, setNewElement] = useState(null);
  const [countries, setCountries] = useState({ features: [] });
  const [backdropInfos, setBackdropInfos] = useState(null);
  const [ringData, setRingData] = useState(null);
  const [arcsData, setArcsData] = useState([]);
  const [filters, setFilters] = useState({
    open: false,
    filterValues: [
      "launch",
      "view",
      "like",
      "share",
      "scan",
      "link",
      "webview",
      "payment",
      "unique",
    ],
  });
  const [isGlobeReady, setIsGlobeReady] = useState(false);
  const [is2DActive, setIs2DActive] = useState(false);
  // useEffect(() => {
  //     // myExpariencesService.getGlobeStats()
  //     //   .then(res => {
  //     //     console.log('res =>', res)
  //     //     const gLabelsData = res.filter(elem => elem.position).map(item => {
  //     //       if (item.position)
  //     //         return ({
  //     //           lat: item.position.coordinates[1],
  //     //           lng: item.position.coordinates[0],
  //     //           size: 1,
  //     //           desc: item.id,
  //     //           color: '#D3AF5F',
  //     //         })
  //     //     }).slice(-300);
  //     //     console.log("gLabelsData =>", gLabelsData)
  //     //     setData(gLabelsData)
  //   // })
  // }, [])

  // useEffect(() => {
  //   console.log("expariences =>", expariences);
  // }, [expariences]);

  // const fetchData = async (route) => {
  //   await fetch("/dataset2.geojson")
  //     .then((res) => res.json())
  //     .then(setCountries);
  //   await fetchEventSource(route, {
  //     method: "GET",
  //     headers: authHeader(true),
  //     openWhenHidden: true,
  //     onopen(res) {
  //       if (res.ok && res.status === 200) {
  //         console.log("Connection made ", res);
  //       } else if (
  //         res.status >= 400 &&
  //         res.status < 500 &&
  //         res.status !== 429
  //       ) {
  //         console.log("Client side error ", res);
  //       }
  //     },
  //     onmessage(event) {
  //       // console.log(props.dataToConcat, props.filterIdValue)
  //       let parsedData = JSON.parse(event.data);
  //       if (props.dataToConcat) {
  //         const key = parsedData.data ? "data" : "initialData";
  //         parsedData[key] = [...parsedData[key], ...props.dataToConcat];
  //       }
  //       if (!status && !parsedData.data) {
  //         setStatus("connected");
  //         const tmpArray = [];
  //         parsedData.initialData.forEach((item) => {
  //           if (item.position) {
  //             const tmp = {
  //               ...item,
  //               lat: item.position.coordinates[1],
  //               lng: item.position.coordinates[0],
  //               title:
  //                 item.exparience?.displayName || item.exparience?.name || "?",
  //               // lat: (Math.random() - 0.5) * 180,
  //               // lng: (Math.random() - 0.5) * 360,
  //               size: 0.5,
  //               color: "#D3AF5F",
  //               alt: 0.002,
  //               nodeRef: createRef(null),
  //               id: guidGenerator(),
  //             };
  //             tmpArray.push(tmp);
  //           }
  //         });
  //         // setExpariences(tmpArray.filter(item => item.type === 'launch'));
  //         if (!props.filterIdValue) {
  //           setExpariences(tmpArray);
  //         }

  //         setSavedData(tmpArray);
  //       }
  //       if (parsedData.data) {
  //         const { position, ...rest } = parsedData.data;
  //         const tmp = {
  //           ...rest,
  //           lat: position.coordinates[1],
  //           lng: position.coordinates[0],
  //           title: rest.exparience.displayName || rest.exparience.name,
  //           size: 0.5,
  //           color: "#D3AF5F",
  //           alt: 0.002,
  //           nodeRef: createRef(null),
  //           id: guidGenerator(),
  //         };
  //         setNewElement(tmp);
  //       }
  //     },
  //     onclose(event) {
  //       console.log("Connection closed by the server >", event);
  //     },
  //     onerror(err) {
  //       console.log("There was an error from server", err);
  //     },
  //   });
  // };

  const addNewData = (data) => {
    const { position, ...rest } = data;
    const tmp = {
      ...rest,
      lat: position.coordinates[1],
      lng: position.coordinates[0],
      title: rest.exparience.displayName || rest.exparience.name,
      size: 0.5,
      color: "#D3AF5F",
      alt: 0.002,
      nodeRef: createRef(null),
      id: guidGenerator(),
    };
    setNewElement(tmp);
  };

  const formatInitialData = async (data) => {
    await fetch("/dataset2.geojson")
      .then((res) => res.json())
      .then(setCountries);
    console.log("data =>", data);
    setStatus("connected");
    const tmpArray = [];
    let tmpData = [...data];
    if (props.dataToConcat) {
      tmpData = [...tmpData, ...props.dataToConcat];
    }
    tmpData.forEach((item) => {
      if (item.position) {
        const tmp = {
          ...item,
          lat: item.position.coordinates[1],
          lng: item.position.coordinates[0],
          title: item.exparience?.displayName || item.exparience?.name || "?",
          // lat: (Math.random() - 0.5) * 180,
          // lng: (Math.random() - 0.5) * 360,
          size: 0.5,
          color: "#D3AF5F",
          alt: 0.002,
          nodeRef: createRef(null),
          id: guidGenerator(),
        };
        tmpArray.push(tmp);
      }
    });
    // setExpariences(tmpArray.filter(item => item.type === 'launch'));
    if (!props.filterIdValue) {
      setExpariences(tmpArray);
    }

    setSavedData(tmpArray);
  };

  useEffect(() => {
    if (props.filterIdValue) {
      setFilters({
        open: false,
        filterValues: [props.filterIdValue],
      });
    }
    setGlobeWidth(document.getElementById("mainContainer").offsetWidth);
    // fetchData(route);

    statsSocket.connect();
    statsSocket.emit(
      "subscribe",
      { exparienceId: props.exparienceId } || {},
      () => console.log("timeout socket")
    );
    statsSocket.on("statistics", (res) => formatInitialData(res.data));
    statsSocket.on("statistics/new", (data) => addNewData(data));

    return () => {
      statsSocket.off("statistics");
      statsSocket.off("statistics/new");
      statsSocket.disconnect();
    };
  }, []);

  const getToastMessage = (type) => {
    switch (type) {
      case "launch":
        return t("toasts.globeExparienceToastLaunched");
      case "view":
        return t("toasts.globeExparienceToastViewed");
      case "like":
        return t("toasts.globeExparienceToastLiked");
      case "share":
        return t("toasts.globeExparienceToastShared");
      case "scan":
        return t("toasts.globeExparienceToastScanned");
      case "link":
        return t("toasts.globeExparienceToastLinked");
      case "webview":
        return t("toasts.globeExparienceToastWebviewed");
      case "payment":
        return t("toasts.globeExparienceToastPayments");
      default:
        return t("toasts.globeExparienceToastLaunched");
    }
  };

  useEffect(() => {
    if (newElement) {
      // avoid too much points in order to keep correct fps
      if (expariences.length >= MAX_POINTS) {
        const tmp = [newElement, ...expariences];
        tmp.pop();
        if (filters.filterValues.includes(newElement.type)) setExpariences(tmp);
        setSavedData(tmp);
      } else {
        if (filters.filterValues.includes(newElement.type))
          setExpariences([newElement, ...expariences]);
        setSavedData([newElement, ...savedData]);
      }
      if (filters.filterValues.includes(newElement.type)) {
        if (!backdropInfos) {
          setRingData(newElement);
          // setBackdropInfos(newElement) // make special variable for ringData
          if (!is2DActive) {
            globeEl.current.pointOfView(
              {
                lat: newElement.lat,
                lng: newElement.lng,
                altitude: 1.5,
              },
              1500
            );
          }
        }
        enqueueSnackbar(
          <Root>
            <div className={classes.notifContainer}>
              <img
                src={newElement.exparience.logoUrl}
                className={classes.exparienceImage}
                alt={`toast-${newElement.exparience.logoUrl}`}
              />
              <div className={classes.textContainer}>
                <Typography variant="body2" color="primary">
                  {newElement.exparience.displayName ||
                    newElement.exparience.name}
                </Typography>
                <Typography variant="body2" color="primary">
                  {getToastMessage(newElement.type)}
                </Typography>
              </div>
            </div>
          </Root>,
          {
            anchorOrigin: {
              vertical: "top",
              horizontal: "right",
            },
            autoHideDuration: 5000,
            className: classes.globeNotif,
          }
        );
      }
      setNewElement(null);
    }
  }, [newElement]);

  useEffect(() => {
    const tmp = [...savedData].filter((item) => {
      return (
        (filters.filterValues.includes("launch") && item.type === "launch") ||
        (filters.filterValues.includes("view") && item.type === "view") ||
        (filters.filterValues.includes("like") && item.type === "like") ||
        (filters.filterValues.includes("share") && item.type === "share") ||
        (filters.filterValues.includes("scan") && item.type === "scan") ||
        (filters.filterValues.includes("link") && item.type === "link") ||
        (filters.filterValues.includes("webview") && item.type === "webview") ||
        (filters.filterValues.includes("payment") && item.type === "payment") ||
        (filters.filterValues.includes("unique") && item.subType === "unique")
      );
    });
    setExpariences(tmp);
  }, [filters.filterValues, savedData]);

  useEffect(() => {
    if (isGlobeReady && !is2DActive) {
      if (backdropInfos) {
        // const elt = document.getElementById("ads-tooltip");
        const coords = globeEl.current.getScreenCoords(
          backdropInfos.lat,
          backdropInfos.lng
        );
        const test = [];
        let altitude = 0;
        for (
          let i = coords.y;
          i <
          (!props.exparienceId ||
          (props.exparienceId && window.location.href.includes("/m/"))
            ? height / 1.5
            : height / 2) -
            (!props.exparienceId ||
            (props.exparienceId && window.location.href.includes("/m/"))
              ? 50
              : 150);
          !props.exparienceId ||
          (props.exparienceId && window.location.href.includes("/m/"))
            ? (i += 10)
            : (i += 3)
        ) {
          const middle = globeEl.current.toGlobeCoords(globeWidth / 2, i);
          test.push([middle.lat, middle.lng, altitude]);
          altitude += 0.01;
        }
        setArcsData([test]);
        globeEl.current.controls().enableRotate = false;
        globeEl.current.controls().enableZoom = false;
      } else {
        globeEl.current.controls().enableRotate = true;
        globeEl.current.controls().enableZoom = true;
        setIsGlobeReady(true);
        setArcsData([]);
      }
    }
  }, [backdropInfos]);

  const handleFilters = (event, newFilters) => {
    if (newFilters.length !== 0)
      setFilters({ ...filters, filterValues: newFilters });
  };

  const getIconType = (type) => {
    switch (type) {
      case "launch":
        return (
          <Root>
            <Lottie
              animationData={RocketLaunch}
              loop={true}
              className={classes.customIconInItem}
            />
          </Root>
        );
      case "view":
        return (
          <Root>
            <Lottie
              animationData={ViewLottie}
              loop={true}
              className={classes.customIconInItem}
            />
          </Root>
        );
      case "like":
        // return <Lottie animationData={LikeLottie} loop={true} className={classes.customIconInItem}/>
        return (
          <Root>
            <Lottie
              animationData={ViewLottie}
              loop={true}
              className={classes.customIconInItem}
            />
          </Root>
        );
      case "share":
        return (
          <Root>
            <Lottie
              animationData={ShareLottie}
              loop={true}
              className={classes.customIconInItem}
            />
          </Root>
        );
      case "scan":
        return (
          <Root>
            <Lottie
              animationData={ScanLottie}
              loop={true}
              className={classes.customIconInItem}
            />
          </Root>
        );
      case "link":
        return (
          <Root>
            <Lottie
              animationData={LinkLottie}
              loop={true}
              className={classes.customIconInItem}
            />
          </Root>
        );
      case "webview":
        return (
          <Root>
            <Lottie
              animationData={WebviewLottie}
              loop={true}
              className={classes.customIconInItem}
            />
          </Root>
        );
      case "payment":
        return (
          <Root>
            <Lottie
              animationData={PaymentLottie}
              loop={true}
              className={classes.customIconInItem}
            />
          </Root>
        );
      case "unique":
        return (
          <Root>
            <Lottie
              animationData={UniqueLottie}
              loop={true}
              className={classes.customIconInItem}
            />
          </Root>
        );
      default:
        return (
          <Root>
            <Lottie
              animationData={RocketLaunch}
              loop={true}
              className={classes.customIconInItem}
            />
          </Root>
        );
    }
  };

  return (
    <Root
      sx={{
        top: props.exparienceId ? "4rem" : 0,
        position: props.exparienceId ? "relative" : "initial",
      }}
    >
      <Container id="mainContainer">
        <span />
      </Container>
      <div style={{ overflow: "hidden" }}>
        <Slide
          direction="up"
          in={backdropInfos ? true : false}
          mountOnEnter
          unmountOnExit
        >
          <div
            onClick={(e) => e.stopPropagation()}
            className={classes.zoneBottomMenu}
            style={{
              marginBottom: props.exparienceId
                ? width >= 768
                  ? "42px"
                  : "60px"
                : "0px",
            }}
          >
            <CloseIcon
              className={classes.closeIconBackdrop}
              onClick={() => {
                setBackdropInfos(null);
                setRingData(null);
              }}
            />
            <BackdropCardInfo element={backdropInfos} />
          </div>
        </Slide>
      </div>
      {status !== "connected" && globeWidth > 0 ? (
        <div className={classes.loadingContainer}>
          <CircularProgress size={50} />
          <Typography>{t("loaders.fetching")}</Typography>
        </div>
      ) : (
        <>
          {is2DActive && expariences.length > 0 ? (
            <div>
              <MyMapContainer
                positions={expariences}
                dashboardMap
                visualize
                backdropInfos={backdropInfos}
                filterValues={filters.filterValues}
                setDatesDisable={() => console.log("no dates")}
              />
            </div>
          ) : (
            <Globe
              ref={globeEl}
              globeImageUrl="https://art-design-story-bucket-prod.s3.fr-par.scw.cloud/bg.png"
              backgroundColor="rgba(0,0,0,0)"
              showAtmosphere={false}
              onGlobeReady={() => {
                if (globeEl.current) {
                  //do not remove
                  // console.log("expariences =>", expariences);
                  globeEl.current.controls().maxDistance = 250;
                  if (expariences.length > 0)
                    globeEl.current.pointOfView(
                      {
                        lat: expariences[expariences.length - 1].position
                          .coordinates[1],
                        lng: expariences[expariences.length - 1].position
                          .coordinates[0],
                        altitude: 1.5,
                      },
                      1500
                    );
                  setIsGlobeReady(true);
                }
              }}
              labelsData={expariences}
              labelLat={(d) => d.lat}
              labelLng={(d) => d.lng}
              labelAltitude={(d) => d.alt}
              labelText={(d) => ""}
              labelSize={(d) => d.size}
              labelDotRadius={(d) => d.size}
              labelColor={() => "rgba(58, 197, 102, 1)"}
              labelsTransitionDuration={2200}
              labelResolution={2}
              onLabelClick={(d, e, element) => {
                setBackdropInfos(null);
                setFilters({ ...filters, open: false });
                const cameraPosition = globeEl.current.toGeoCoords(
                  globeEl.current.controls().object.position
                );
                if (
                  Math.round(cameraPosition.lat) - Math.round(element.lat) >
                    1 ||
                  Math.round(cameraPosition.lat) - Math.round(element.lat) <
                    0 ||
                  Math.round(cameraPosition.lng) - Math.round(element.lng) >
                    1 ||
                  Math.round(cameraPosition.lng) - Math.round(element.lng) < 0
                ) {
                  globeEl.current.pointOfView(
                    {
                      lat: element.lat,
                      lng: element.lng,
                      altitude: 1.5,
                    },
                    1500
                  );
                  setTimeout(() => setBackdropInfos(d), 1500);
                } else {
                  setBackdropInfos(d);
                }
              }}
              hexPolygonsData={countries.features}
              hexPolygonResolution={3}
              hexPolygonMargin={0.6}
              hexPolygonColor={() => `#D3AF5F`}
              width={globeWidth}
              height={
                !props.exparienceId ||
                (props.exparienceId && window.location.href.includes("/m/"))
                  ? height / 1.5
                  : height / 2
              }
              pathsData={arcsData}
              pathStroke={2}
              pathDashLength={0.01}
              pathDashGap={0}
              pathDashAnimateTime={100}
              pathPointAlt={(pnt) => pnt[2]}
            />
          )}

          {((!is2DActive && isGlobeReady) || is2DActive) && (
            <Paper
              elevation={0}
              // className={
              //   props.exparienceId
              //     ? classes.fifoExparienceContainer
              //     : classes.fifoContainer
              // }
              className={classes.fifoContainer}
              style={{
                zIndex:
                  !props.exparienceId ||
                  (props.exparienceId && window.location.href.includes("/m/"))
                    ? 99
                    : 9999,
              }}
            >
              <div className={classes.fifoTitleRow}>
                <Button
                  variant="contained"
                  color="primary"
                  onClick={() => setIs2DActive(!is2DActive)}
                  className={classes.toggleMapButton}
                  size="small"
                >
                  {!is2DActive ? t("dashboard.2dmode") : t("dashboard.3dmode")}
                </Button>
                <ToggleButtonGroup
                  value={filters.filterValues}
                  onChange={handleFilters}
                  className={classes.toggleFilters}
                >
                  <ToggleButton
                    value="payment"
                    aria-label="payment"
                    className={classes.filterButtonMargin}
                  >
                    <Lottie
                      animationData={PaymentLottie}
                      loop={true}
                      className={classes.customIcon}
                      style={{
                        width: "25px",
                        height: "25px",
                        margin: "0 10px",
                      }}
                    />
                    {t("dashboard.paymentsFilter")}
                  </ToggleButton>
                  <ToggleButton
                    value="launch"
                    aria-label="launch"
                    className={classes.filterButtonMargin}
                  >
                    <Lottie
                      animationData={RocketLaunch}
                      loop={true}
                      className={classes.customIcon}
                    />
                    {t("dashboard.launchFilter")}
                  </ToggleButton>
                  <ToggleButton
                    value="webview"
                    aria-label="webview"
                    className={classes.filterButtonMargin}
                  >
                    <Lottie
                      animationData={WebviewLottie}
                      loop={true}
                      className={classes.customIcon}
                      style={{ width: "55px", height: "55px" }}
                    />
                    {t("dashboard.webviewFilter")}
                  </ToggleButton>
                  <ToggleButton
                    value="view"
                    aria-label="view"
                    className={classes.filterButtonMargin}
                  >
                    <Lottie
                      animationData={ViewLottie}
                      loop={true}
                      className={classes.customIcon}
                    />
                    {t("dashboard.viewFilter")}
                  </ToggleButton>
                  <ToggleButton
                    value="like"
                    aria-label="like"
                    className={classes.filterButtonMargin}
                  >
                    <Lottie
                      animationData={LikeLottie}
                      loop={true}
                      className={classes.customIcon}
                    />
                    {t("dashboard.likeFilter")}
                  </ToggleButton>
                  <ToggleButton
                    value="share"
                    aria-label="share"
                    className={classes.filterButtonMargin}
                  >
                    <Lottie
                      animationData={ShareLottie}
                      loop={true}
                      className={classes.customIcon}
                    />
                    {t("dashboard.shareFilter")}
                  </ToggleButton>
                  <ToggleButton
                    value="scan"
                    aria-label="scan"
                    className={classes.filterButtonMargin}
                  >
                    <Lottie
                      animationData={ScanLottie}
                      loop={true}
                      className={classes.customIcon}
                    />
                    {t("dashboard.scanFilter")}
                  </ToggleButton>
                  <ToggleButton
                    value="link"
                    aria-label="link"
                    className={classes.filterButtonMargin}
                  >
                    <Lottie
                      animationData={LinkLottie}
                      loop={true}
                      className={classes.customIcon}
                      style={{
                        width: "20px",
                        height: "20px",
                        margin: "0 10px",
                      }}
                    />
                    {t("dashboard.linkFilter")}
                  </ToggleButton>
                  <ToggleButton
                    value="unique"
                    aria-label="unique"
                    className={classes.filterButtonMargin}
                  >
                    <Lottie
                      animationData={UniqueLottie}
                      loop={true}
                      className={classes.customIcon}
                      style={{
                        width: "40px",
                        height: "40px",
                        margin: "0 10px",
                      }}
                    />
                    {t("dashboard.uniqueVisitor")}
                  </ToggleButton>
                </ToggleButtonGroup>
              </div>
              {!props.exparienceId && (
                <Paper elevation={0}>
                  <Fade in={expariences.length === 0}>
                    <div className={classes.noItemsContainer}>
                      <Typography
                        variant="body1"
                        className={classes.noItemsTitle}
                      >
                        {t("dashboard.noItemsTitle")}
                      </Typography>
                    </div>
                  </Fade>
                  <TransitionGroup className={classes.fifoList}>
                    {expariences.slice(0, 49).map((item, index) => {
                      return (
                        <CSSTransition
                          key={item.id}
                          nodeRef={item.nodeRef}
                          timeout={1000}
                          classNames="item"
                        >
                          <div
                            className={classes.fifoItem}
                            ref={item.nodeRef}
                            onClick={() => {
                              if (is2DActive) {
                                setBackdropInfos(item);
                              } else {
                                const cameraPosition =
                                  globeEl.current.toGeoCoords(
                                    globeEl.current.controls().object.position
                                  );
                                if (
                                  Math.round(cameraPosition.lat) -
                                    Math.round(item.lat) >
                                    1 ||
                                  Math.round(cameraPosition.lat) -
                                    Math.round(item.lat) <
                                    0 ||
                                  Math.round(cameraPosition.lng) -
                                    Math.round(item.lng) >
                                    1 ||
                                  Math.round(cameraPosition.lng) -
                                    Math.round(item.lng) <
                                    0
                                ) {
                                  globeEl.current.pointOfView(
                                    {
                                      lat: item.lat,
                                      lng: item.lng,
                                      altitude: 1.5,
                                    },
                                    1500
                                  );
                                  setTimeout(
                                    () => setBackdropInfos(item),
                                    1500
                                  );
                                } else {
                                  setBackdropInfos(item);
                                }
                                setRingData(item);
                              }
                            }}
                          >
                            {getIconType(item.type)}
                            <img
                              src={item.exparience?.logoUrl || LogoByAds}
                              className={classes.fifoImage}
                              alt={`fifo-${index + 1}`}
                            />
                            <div className={classes.exparienceNameContainer}>
                              <Typography
                                variant="body2"
                                className={classes.fifoExparienceName}
                              >
                                {item.exparience?.displayName ||
                                  item.exparience?.name}
                              </Typography>
                            </div>
                          </div>
                        </CSSTransition>
                      );
                    })}
                  </TransitionGroup>
                </Paper>
              )}
            </Paper>
          )}
        </>
      )}
    </Root>
  );
};

export default GlobeGl;
